/* ============================================================
   FOURS+ Theme JS — v2.0
   Vanilla, no dependencies. Everything is namespaced on window.Fours.
   ============================================================ */
(function () {
  'use strict';

  var Fours = window.Fours = window.Fours || {};
  var cfg = window.FOURS || {};

  /* ---------- Helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // Shopify-compatible money formatter driven by the shop's money_format.
  function formatMoney(cents) {
    var fmt = cfg.moneyFormat || '£{{amount}}';
    function num(precision, thousands, decimal) {
      var value = (isNaN(cents) || cents == null) ? 0 : cents;
      value = (value / 100).toFixed(precision);
      var parts = value.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, token) {
      switch (token) {
        case 'amount': return num(2, ',', '.');
        case 'amount_no_decimals': return num(0, ',', '.');
        case 'amount_with_comma_separator': return num(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return num(0, ' ', '.');
        case 'amount_with_space_separator': return num(2, ' ', ',');
        default: return '';
      }
    });
  }
  Fours.formatMoney = formatMoney;

  // Resize a Shopify CDN image URL (works for /cdn/shop/... URLs).
  function imgSize(url, size) {
    if (!url) return '';
    return url.replace(/(\.[a-zA-Z]{3,4})(\?.*)?$/, '_' + size + '$1$2');
  }

  function showToast(msg) {
    var t = $('#toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove('show'); }, 3200);
  }
  Fours.toast = showToast;

  /* ---------- Header height → --nav-h (sticky offsets everywhere) ---------- */
  var siteTop = $('#site-top');
  function syncNavHeight() {
    if (!siteTop) return;
    document.documentElement.style.setProperty('--nav-h', siteTop.offsetHeight + 'px');
  }
  syncNavHeight();
  window.addEventListener('resize', syncNavHeight);
  window.addEventListener('load', syncNavHeight);
  if ('ResizeObserver' in window && siteTop) new ResizeObserver(syncNavHeight).observe(siteTop);

  var header = $('#fours-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 20); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Drawers (cart, mobile nav, search) ---------- */
  var overlay = $('#fours-overlay');
  var cartDrawer = $('#cart-drawer');
  var mobDrawer = $('#mob-drawer');
  var navSearch = $('#nav-search');
  var lastFocus = null;

  // iOS Safari ignores `body{overflow:hidden}` — the page behind a drawer keeps scrolling,
  // and closing it leaves you somewhere else on the page. Pinning the body with
  // position:fixed is the only reliable lock; we stash the offset and restore it on unlock.
  // The drawers have their own overflow-y:auto, so they still scroll while body is pinned.
  var lockedAt = 0;

  function lockScroll(lock) {
    var b = document.body;
    if (lock) {
      if (b.style.position === 'fixed') return;
      lockedAt = window.scrollY || window.pageYOffset || 0;
      b.style.position = 'fixed';
      b.style.top = (-lockedAt) + 'px';
      b.style.left = '0';
      b.style.right = '0';
      b.style.width = '100%';
      b.style.overflow = 'hidden';
    } else {
      if (b.style.position !== 'fixed') return;
      b.style.position = '';
      b.style.top = '';
      b.style.left = '';
      b.style.right = '';
      b.style.width = '';
      b.style.overflow = '';
      // Restore instantly — smooth scrolling here would animate the jump back.
      var prev = document.documentElement.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'auto';
      window.scrollTo(0, lockedAt);
      document.documentElement.style.scrollBehavior = prev;
    }
  }

  function openCart() {
    lastFocus = document.activeElement;
    if (mobDrawer) mobDrawer.classList.remove('open');
    if (cartDrawer) { cartDrawer.classList.add('open'); cartDrawer.setAttribute('aria-hidden', 'false'); }
    if (overlay) overlay.classList.add('active');
    lockScroll(true);
    var close = $('#cart-close-btn');
    if (close) setTimeout(function () { close.focus(); }, 50);
  }
  function openMob() {
    lastFocus = document.activeElement;
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (mobDrawer) { mobDrawer.classList.add('open'); mobDrawer.setAttribute('aria-hidden', 'false'); }
    if (overlay) overlay.classList.add('active');
    lockScroll(true);
  }
  function closeAll() {
    var wasOpen = false;
    [cartDrawer, mobDrawer].forEach(function (d) {
      if (d && d.classList.contains('open')) { wasOpen = true; d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); }
    });
    if (overlay) overlay.classList.remove('active');
    lockScroll(false);
    if (wasOpen && lastFocus && lastFocus.focus) lastFocus.focus();
  }
  Fours.openCart = openCart;
  Fours.closeDrawers = closeAll;

  document.addEventListener('click', function (e) {
    if (e.target.closest('#cart-toggle-btn')) { e.preventDefault(); openCart(); fetchCart(); }
    else if (e.target.closest('#hamburger-btn')) { openMob(); }
    else if (e.target.closest('#cart-close-btn, #mob-close-btn')) { closeAll(); }
    else if (e.target.closest('#search-toggle-btn')) {
      if (!navSearch) return;
      var open = navSearch.classList.toggle('open');
      syncNavHeight();
      if (open) { var inp = navSearch.querySelector('input'); if (inp) inp.focus(); }
    }
  });
  if (overlay) overlay.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAll();
      if (navSearch && navSearch.classList.contains('open')) { navSearch.classList.remove('open'); syncNavHeight(); }
      $$('.fdd.open').forEach(function (d) { d.classList.remove('open'); });
    }
  });

  /* ---------- Cart ---------- */
  function fetchCart() {
    return fetch(cfg.cartUrl ? cfg.cartUrl + '.js' : '/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartUI(cart); return cart; })
      .catch(function () {});
  }
  Fours.fetchCart = fetchCart;

  function renderCartItem(item) {
    var key = escapeHtml(item.key);
    var name = escapeHtml(item.product_title);
    var brand = escapeHtml(item.vendor);
    var variant = (item.variant_title && item.variant_title !== 'Default Title') ? escapeHtml(item.variant_title) : '';
    var url = escapeHtml(item.url);
    var img = item.image
      ? '<a href="' + url + '"><img class="cart-item-img" src="' + escapeHtml(imgSize(item.image, '160x200_crop_center')) + '" alt="' + name + '" width="76" height="96"/></a>'
      : '<div class="cart-item-img"></div>';
    return '<div class="cart-item" data-key="' + key + '">' + img +
      '<div class="cart-item-info">' +
        (brand ? '<div class="cart-item-brand">' + brand + '</div>' : '') +
        '<a href="' + url + '" class="cart-item-name">' + name + '</a>' +
        (variant ? '<div class="cart-item-variant">' + variant + '</div>' : '') +
        '<div class="cart-item-price">' + formatMoney(item.final_line_price) + '</div>' +
        '<div class="cart-qty">' +
          '<button type="button" class="cart-qty-btn" data-key="' + key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
          '<span class="cart-qty-val">' + item.quantity + '</span>' +
          '<button type="button" class="cart-qty-btn" data-key="' + key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="cart-item-remove" data-key="' + key + '" data-qty="0" aria-label="Remove item">&#10005;</button>' +
    '</div>';
  }

  function updateCartUI(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;
    $$('#cart-count, .cart-count').forEach(function (el) { el.textContent = cart.item_count; });
    var itemsEl = $('#cart-items-list');
    if (itemsEl) {
      itemsEl.classList.remove('is-loading');
      itemsEl.innerHTML = cart.item_count === 0
        ? '<div class="cart-empty">Your cart is empty</div>'
        : cart.items.map(renderCartItem).join('');
    }
    var sub = $('#cart-subtotal-price');
    if (sub) sub.textContent = formatMoney(cart.total_price);
    var checkout = $('#cart-drawer .cart-checkout-btn');
    if (checkout) checkout.classList.toggle('is-disabled', cart.item_count === 0);
  }

  function changeQty(key, qty) {
    if (isNaN(qty) || qty < 0) qty = 0;
    var list = $('#cart-items-list');
    if (list) list.classList.add('is-loading');
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (cart && cart.status) throw cart;
      updateCartUI(cart);
      if (document.body.classList.contains('template-cart')) window.location.reload();
      return cart;
    })
    .catch(function (err) {
      if (list) list.classList.remove('is-loading');
      showToast((err && err.description) || 'Could not update your cart.');
    });
  }
  Fours.changeQty = changeQty;

  // Delegated qty / remove buttons (drawer + cart page). Cart page links carry data-key too.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-key][data-qty]');
    if (!btn) return;
    e.preventDefault();
    changeQty(btn.getAttribute('data-key'), parseInt(btn.getAttribute('data-qty'), 10));
  });

  // Product-page quantity stepper
  document.addEventListener('click', function (e) {
    var qb = e.target.closest('.qty-btn');
    if (!qb) return;
    var wrap = qb.closest('.qty-selector');
    var input = wrap && wrap.querySelector('.qty-input');
    if (!input) return;
    var step = parseInt(qb.getAttribute('data-step'), 10) || 0;
    var max = parseInt(input.getAttribute('max'), 10);
    var val = (parseInt(input.value, 10) || 1) + step;
    if (val < 1) val = 1;
    if (!isNaN(max) && max > 0 && val > max) val = max;
    input.value = val;
  });

  // AJAX add to cart — delegated so every /cart/add form is caught.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var data = new FormData(form);
    var id = data.get('id');
    if (!id) { showToast('Please select an option.'); return; }
    var submit = form.querySelector('[type="submit"]');
    var originalText = submit ? submit.textContent : '';
    if (submit) { submit.disabled = true; submit.textContent = 'Adding…'; }
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: parseInt(data.get('quantity'), 10) || 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function (res) {
      if (res && res.status) throw res;
      return fetchCart();
    })
    .then(function () { openCart(); })
    .catch(function (err) {
      showToast((err && err.description) || 'Sorry, that could not be added to your cart.');
    })
    .then(function () { if (submit) { submit.disabled = false; submit.textContent = originalText; } });
  });

  /* ---------- Generic dropdowns (.fdd) ---------- */
  function isNarrow() { return window.matchMedia('(max-width:768px)').matches; }
  var lastOpen = 0;

  Fours.toggleDropdown = function (el) {
    if (typeof el === 'string') el = $('#fdd-' + el);
    if (!el) return;
    var isOpen = el.classList.contains('open');
    $$('.fdd.open').forEach(function (d) { d.classList.remove('open'); });
    if (isOpen) return;
    var trigger = el.querySelector('.fdd-trigger');
    var menu = el.querySelector('.fdd-menu');
    // Below 768px the menu is a full-width panel positioned entirely in CSS, pinned under
    // the sticky filter bar. Clear any inline coords (a rotation can cross the breakpoint
    // with them still set) and let the stylesheet own it — inline styles would win.
    if (trigger && menu && !isNarrow()) {
      var r = trigger.getBoundingClientRect();
      menu.style.top = (r.bottom + 6) + 'px';
      var left = r.left;
      menu.style.left = '0px';
      el.classList.add('open');
      var mw = menu.offsetWidth;
      if (left + mw > window.innerWidth - 8) left = Math.max(8, window.innerWidth - mw - 8);
      menu.style.left = left + 'px';
    } else {
      // Mobile: CSS owns left/right (full-width panel); we own only `top`, taken from the
      // trigger's live rect so it is correct whether .filter-bar is in flow or sticky-pinned.
      if (menu) { menu.style.left = ''; }
      el.classList.add('open');
      syncMenuTop(el);
    }
    lastOpen = Date.now();
  };

  // Keep the open mobile panel glued under its trigger as the sticky bar pins/unpins.
  function syncMenuTop(el) {
    if (!isNarrow()) return;
    var open = el || document.querySelector('.fdd.open');
    if (!open) return;
    var trigger = open.querySelector('.fdd-trigger');
    var menu = open.querySelector('.fdd-menu');
    if (!trigger || !menu) return;
    var bar = trigger.closest('.filter-bar, .reviews-filter');
    var bottom = (bar || trigger).getBoundingClientRect().bottom;
    menu.style.top = Math.max(0, Math.round(bottom)) + 'px';
  }

  var syncQueued = false;
  function queueMenuSync() {
    if (syncQueued) return;
    syncQueued = true;
    requestAnimationFrame(function () { syncQueued = false; syncMenuTop(); });
  }
  window.addEventListener('scroll', queueMenuSync, { passive: true });
  window.addEventListener('resize', queueMenuSync);
  window.toggleFdd = Fours.toggleDropdown; // legacy alias
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.fdd')) $$('.fdd.open').forEach(function (d) { d.classList.remove('open'); });
  });
  window.addEventListener('scroll', function () {
    // On mobile the panel is pinned to the sticky bar, so it stays correct while scrolling
    // and closing would be wrong — a tap can itself emit a scroll (URL-bar collapse,
    // leftover momentum), which would shut the menu the instant it opened. Desktop still
    // closes on scroll because there the menu is anchored by absolute coordinates.
    if (isNarrow()) return;
    if (Date.now() - lastOpen < 350) return;
    $$('.fdd.open').forEach(function (d) { d.classList.remove('open'); });
  }, { passive: true });

  /* ---------- Product page: variants + gallery ---------- */
  function initProduct() {
    var root = $('[data-product-page]');
    if (!root) return;

    // Variants
    var dataEl = $('#product-json');
    var product = null;
    try { product = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (err) { product = null; }
    var select = $('#variant-select');
    var priceEl = $('#product-price');
    var compareEl = $('#product-compare');
    var saveEl = $('#product-save');
    var cta = $('#main-cta-btn');
    var ctaDefault = cta ? cta.getAttribute('data-label') : '';
    var qtyInput = $('.qty-input', root);

    function applyVariant(v) {
      if (!v) return;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (compareEl) { compareEl.textContent = onSale ? formatMoney(v.compare_at_price) : ''; compareEl.hidden = !onSale; }
      if (saveEl) {
        if (onSale) { saveEl.textContent = 'Save ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; saveEl.hidden = false; }
        else saveEl.hidden = true;
      }
      if (cta) {
        cta.disabled = !v.available;
        cta.textContent = v.available ? ctaDefault : 'Sold Out';
      }
      if (qtyInput && v.inventory_management && v.inventory_quantity > 0) qtyInput.setAttribute('max', v.inventory_quantity);
      else if (qtyInput) qtyInput.removeAttribute('max');
      if (v.featured_image && v.featured_image.src) {
        var idx = v.featured_image.position;
        var thumb = $('.gallery-thumb[data-index="' + idx + '"]');
        if (thumb) selectImage(thumb);
      }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (err) {}
    }
    if (select && product) {
      select.addEventListener('change', function () {
        var id = parseInt(select.value, 10);
        var v = product.variants.filter(function (x) { return x.id === id; })[0];
        applyVariant(v);
      });
    }

    // Gallery
    var mainImg = $('#main-product-img');
    var thumbs = $$('.gallery-thumb');
    var counter = $('#gallery-counter');
    var current = 0;

    function selectImage(btn) {
      if (!btn || !mainImg) return;
      var src = btn.getAttribute('data-src');
      var srcset = btn.getAttribute('data-srcset');
      current = thumbs.indexOf(btn);
      mainImg.classList.add('is-fading');
      var swap = function () {
        mainImg.src = src;
        if (srcset) mainImg.srcset = srcset;
        mainImg.alt = btn.getAttribute('data-alt') || mainImg.alt;
        mainImg.classList.remove('is-fading');
      };
      var pre = new Image();
      pre.onload = swap; pre.onerror = swap;
      pre.src = src;
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      btn.classList.add('active');
      btn.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      if (counter) counter.textContent = String(current + 1).padStart(2, '0') + ' / ' + String(thumbs.length).padStart(2, '0');
    }
    function step(dir) {
      if (!thumbs.length) return;
      var next = (current + dir + thumbs.length) % thumbs.length;
      selectImage(thumbs[next]);
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { selectImage(t); }); });
    var prev = $('.gallery-nav--prev'), next = $('.gallery-nav--next');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    var gallery = $('.product-gallery');
    if (gallery && thumbs.length > 1) {
      gallery.setAttribute('tabindex', '0');
      gallery.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      });
      var tx = null;
      gallery.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
      gallery.addEventListener('touchend', function (e) {
        if (tx == null) return;
        var dx = e.changedTouches[0].clientX - tx;
        if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
        tx = null;
      }, { passive: true });
    }
    var active = $('.gallery-thumb.active');
    if (active) current = thumbs.indexOf(active);
  }

  /* ---------- Showcase drag ---------- */
  function initShowcase() {
    var wrap = $('#showcase-track-wrap');
    var track = $('#showcase-track');
    var dotsWrap = $('#showcase-dots');
    if (!wrap || !track) return;
    var cards = $$('.showcase-card', track);
    if (!cards.length) return;
    var gap = 16;

    function cardStep() { return cards[0].offsetWidth + gap; }
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      cards.forEach(function (_, idx) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'showcase-dot' + (idx === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'Go to item ' + (idx + 1));
        dot.addEventListener('click', function () { wrap.scrollTo({ left: idx * cardStep(), behavior: 'smooth' }); });
        dotsWrap.appendChild(dot);
      });
    }
    function updateDots() {
      if (!dotsWrap) return;
      var idx = Math.round(wrap.scrollLeft / cardStep());
      $$('.showcase-dot', dotsWrap).forEach(function (d, i) { d.classList.toggle('active', i === idx); });
    }
    wrap.addEventListener('scroll', updateDots, { passive: true });

    var dragging = false, startX = 0, startScroll = 0, moved = false;
    wrap.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      dragging = true; moved = false; startX = e.clientX; startScroll = wrap.scrollLeft;
      wrap.classList.add('is-dragging');
      e.preventDefault();
    });
    window.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      wrap.scrollLeft = startScroll - dx;
    });
    window.addEventListener('mouseup', function () {
      if (!dragging) return;
      dragging = false;
      wrap.classList.remove('is-dragging');
      updateDots();
    });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  }

  /* ---------- Home hero lines ---------- */
  function initHero() {
    var lines = $$('.hero-gl');
    if (lines.length) setTimeout(function () { lines.forEach(function (l) { l.classList.add('drawn'); }); }, 300);
    var iv = $('.hero-iv');
    if (iv && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.addEventListener('scroll', function () {
        iv.style.transform = 'translate(-50%, calc(-50% + ' + (window.pageYOffset * 0.15) + 'px))';
      }, { passive: true });
    }
  }

  /* ---------- Init ---------- */
  function init() {
    initProduct();
    initShowcase();
    initHero();
    if (cartDrawer) cartDrawer.setAttribute('aria-hidden', 'true');
    if (mobDrawer) mobDrawer.setAttribute('aria-hidden', 'true');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Legacy globals kept for any custom code referencing them.
  window.showToast = showToast;
  window.foursChangeQty = changeQty;
  window.removeCartItem = function (key) { changeQty(key, 0); };
})();